"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementDimension = void 0;
const react_1 = require("react");
const _ = require("lodash");
/**
 * Hook returning a ref and dimensions of the div the ref attaches to.
 * It also handle window resizing
 */
const useElementDimension = () => {
    const elRef = (0, react_1.useRef)();
    const [elDimensions, setElDimensions] = (0, react_1.useState)({
        height: null,
        width: null
    });
    const handleResize = () => {
        if (!elRef.current)
            return;
        setElDimensions({
            height: elRef.current.offsetHeight,
            width: elRef.current.offsetWidth
        });
    };
    const handleResizeDebounced = _.debounce(handleResize, 200);
    // HACK needs timeout for complete draw
    (0, react_1.useLayoutEffect)(() => {
        setTimeout(() => {
            handleResize();
        });
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener("resize", handleResizeDebounced);
        return () => window.removeEventListener("resize", handleResizeDebounced);
    }, []);
    return (0, react_1.useMemo)(() => [elRef, Object.assign({}, elDimensions)], [elRef, elDimensions]);
};
exports.useElementDimension = useElementDimension;
//# sourceMappingURL=useElementDimension.js.map